import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const Container = styled.div`
  .title {
    font-size: 20px;
    height: 72px;
    margin-left: -1rem;
  }
  .subtitle {
    font-size: 15px;
  }
  p:hover {
    color: red;
  }
  .card-content {
    padding: 1.5rem;
  }
`;
const Card = ({ img, title, date, subtitle, linkTo }) => (
  <Container>
    <div className="column">
      <div className="column">
        <figure
          className="image is-5by4
">
          <img alt="" src={img} />
        </figure>
      </div>
      <div className="card-content">
        <p className="title pb-5 has-text-weight-bold has-text-centered">
          {title}
        </p>
        <p className="has-text-grey">{date}</p>
        <p className="subtitle has-text-weight-semibold has-text-centered">
          {subtitle}
        </p>
        <Link to={linkTo} type="button" className="button is-danger">
          Read More
        </Link>
      </div>
    </div>
  </Container>
);
export default Card;
